import { API, Competition,CompetitionAPI,LangObject, PageModel } from "@brg/api";
import { useProfile } from "@brg/auth";
import { Dropdown, DropdownListItem, FlexBox, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { LayoutConst } from "core";
import { useState, FC, useMemo, useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { ApplicationTheme } from "shared/themes";
import { VOTE_BLOCK_POSITION } from "../../sections/ps-bottom";
import useQueryState from "shared/hooks/useQueryState";
import { STATUSES } from "_competition/const";
import { CreateLinkTo } from "shared/constants/linkTo";
import { GRID_TEMP, MARK_HEIGHT, MARK_WIDTH } from "../const/markSizes";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { Container, CriteryName, CriteryWrapper, DropdownText, MarkList, RectangleCount, SkelectonCard, VoteButton, VoteTitle, VoteWrapper } from "./styles";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ReactTooltip from "react-tooltip";
import { getCompetitionTitle } from "_competition/pages/AllCompetitionsPage/helpers/competitionUtils";
import { PROJECT_VOTE_STATUS, useVoteContest } from "core/providers/VoteProvider";
import { ProgressBar } from "shared/icons/Progress";
import { useTheme } from "styled-components";
import { useGetFriendlyUrlParam } from "shared/hooks/useGetFriendlyUrlParam";

const ArrowRight: FC = () => {
    return (
      <svg width="9" height="12" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.65801 7L0.723468 12.7402C0.425507 13.0284 0.425511 13.4957 0.723476 13.7839C1.02144 14.0721 1.50453 14.072 1.80249 13.7838L8.27653 7.52183C8.57449 7.23363 8.57449 6.76637 8.27653 6.47817L1.80249 0.216154C1.50453 -0.0720489 1.02144 -0.0720514 0.723476 0.216148C0.425511 0.504347 0.425507 0.971612 0.723468 1.25981L6.65801 7Z"
          fill="#FEFEFE"/>
      </svg>
    )
  }

export interface Criteria {
    voteCriteriaId: string;
    name: string | LangObject[];
    nominationId?: string;
    minValue: number;
    maxValue: number;
    weight?: number;
    currentLang?: string;
    isNew?: boolean;
  }

const VoteBlock: FC<{ project: any, fullSize?: boolean, position: VOTE_BLOCK_POSITION}> = ({
    project,
    fullSize,
    position,
  }) => {
  
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const id = useGetFriendlyUrlParam("id");
    const requestDataRef = useRef<any>(null);
    const themeWhite = ApplicationTheme.white;
    const profile = useProfile();
    const toasts = useToasts();
    const theme = useTheme();
    const [competition, setCompetition] = useState<Competition>();
    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [loaderVisible, setLoaderVisible] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState<string | undefined>();
    const [disableNext, setDisableNext] = useState(false);
    const [nextUnrated, setNextUnrated] = useState<string>();
    const [{ currentCompetitionId }, setQueryParams] = useQueryState();
  
    const { 
      criteriaList,
      currentList, 
      currentCompId,
      isLoading, 
      voteEnd, 
      nextCriteriaId,
      prevCriteriaId, 
      setFilter,
      setVote,
      resetData,
      updateData, 
    } = useVoteContest();

    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);
  
    //Номинация
    const nomination = useMemo(
      () => competition?.nominations?.length ? competition.nominations[0] : null,
      [competition]
    );

    const criterias = useMemo(
      () => (((nomination as any)?.voteCriterias as Criteria[]) ?? [])
        .map(x => {
          return {...x, maxValue: nomination?.customVoteMaxValue || x.maxValue} as Criteria
        }),
      [nomination]
    );

    const competitionIds = useMemo(() => {
      //@ts-ignore
      const competitionIds: Nullable<string[]> = project?.competitionApproves?.map(({ competitionId }) => competitionId);
      return competitionIds;
    }, [project]);

    useEffect(() => {
      if (competitions.length > 0 && activeTabKey) {
        setCompetition(competitions.find(x => x.competitionId === activeTabKey));
      } else {
        setCompetition(undefined);
      }
    }, [competitions, activeTabKey]);

    const fetchCompetitions = () => {
        CompetitionAPI.GetList({
          initTags: true,
          competitionIds: competitionIds,
          competitionStatus: [STATUSES.Voting.valueOf()],
          byJuryIds: [profile?.designerId],
          exams: true,
          includeRatings: true
        })
          .then((v) => v.json())
          .then((v) => API.toLang<PageModel<Competition>>(v, i18n?.language))
          .then((v) => {
            setCompetitions(v.data)
          });
   
    }
  
    const competitionTabs = useMemo(() => {
      const tabs: Record<string, string> = {};
  
      competitions.forEach(x => {
        //@ts-ignore
        tabs[x.competitionId] = getCompetitionTitle(x);
      });
  
      return tabs;
    }, [competitions]);
  
    //@ts-ignore
    const currentId = useMemo(() => {
      const storedCompetitionId = currentCompetitionId || sessionStorage.getItem('voteId');
      //@ts-ignore
      return !!project?.competitionApproves?.find?.(({ competitionId }) => competitionId === (storedCompetitionId)) ? storedCompetitionId : currentCompId
    }, [project, currentCompId, currentCompetitionId])

    // useEffect(() => {
    //   if (activeTabKey) {
    //     setCompetititionId(
    //       Object.keys(competitionTabs)?.find(
    //         (k) => k === activeTabKey) || ''
    //     )
    //   }
    // }, [activeTabKey, competitionTabs])
  
    useEffect(() => {
      const keys = Object.keys(competitionTabs);
  
      if ((keys && keys.length > 0) || currentId) {
        setActiveTabKey(currentId || keys[0]);
      } else {
        setActiveTabKey(undefined);
      }
  
    }, [competitionTabs, currentId])

    // console.log(`tst crt: ${criteriaList?.[0]?.projectId} - curr: ${project?.projectId} - next: ${nextCriteriaId}` )

    useEffect(() => {
      if (profile && requestDataRef?.current?.projectId === id && requestDataRef.current?.competitionId === currentId && !isLoading) {
        setFilter({
          ...requestDataRef?.current,
          competitionStatus: [STATUSES.Voting.valueOf()],
          profile: profile.designerId,
          competitionId: currentId,
          lang: i18n.language,
          disableRequest: !project?.competitionIds?.length
        })
      }
    }, [i18n.language, project, currentId, setFilter, isLoading, competitionIds, requestDataRef.current, id, profile]);

      //@ts-ignore
      requestDataRef.current = {
        competitionId: currentId,
        competitionIds: competitionIds,
        disableRequest: !project?.competitionIds?.length,
        projectId: id
      };

      useEffect(() => {
        if (profile && competitionIds?.length) {
          fetchCompetitions()
        } 
      } , [profile, competitionIds])

      useEffect(() => {
        if (!currentCompetitionId && competition && nomination) {
          setQueryParams({ 
            currentCompetitionId: competition?.competitionId
          })
        }
      } , [
        currentCompetitionId, 
        competition, 
        nomination, 
        setQueryParams
      ])

      useEffect(() => {
        resetData && resetData()
      }, [])
    
    // const isEqual = useMemo(() => {
    //   return !!Object.values(criteriaList)?.length && 
    //   !!Object.values(currentList)?.length && 
    //   Object.values(criteriaList).length === Object.values(currentList).length 
    // }, [criteriaList, currentList])
  
    const hasVoteValues = useMemo(
      () => (!isLoading && !!competition && criteriaList && (Object.values(criteriaList)?.every(({ voteValue }) => voteValue !== -1))) , [competition, isLoading, criteriaList])
  
    const isNextButtonEnabled = useMemo(() => {
      return nextCriteriaId !== '' && !isLoading && !!competition && criteriaList && (Object.values(criteriaList)?.every(({ voteValue }) => voteValue !== -1) || !!nextUnrated) && hasVoteValues
    }, [criteriaList, nextUnrated, competition, isLoading, nextCriteriaId, hasVoteValues])

    const showedEndModal = useMemo(
      () => {
        if (voteEnd === PROJECT_VOTE_STATUS.end) return true;
        else {
          let voteList = JSON.parse(
            JSON.stringify(
              localStorage.getItem(
                'showedVoteModal'
              ) ?? '[]'
            )
          );
          if (!Array.isArray(voteList)) {
            voteList = [voteList]
          }

          return voteList?.includes(currentId) 
        }
      } , [voteEnd, currentId])
    // const isPrevButtonEnabled = useMemo(() => (prevCriteriaId !== '' && prevCriteriaId !== id), [prevCriteriaId, id])
    const isPrevButtonEnabled = false;

    const goNext = () => {

      if (showedEndModal) {
        toasts.error(t('vote_over'));
        return;
      }

      if (!isNextButtonEnabled) {
        toasts.error(t('fill_vote'));
        return;
      }

      if (nextCriteriaId !== '') {

        setLoaderVisible(true);

        setTimeout(() => {
          history.push(`${CreateLinkTo.project(nextCriteriaId ?? '')}?currentCompetitionId=${currentId}`);
        
          updateLocalFilter({
            competitionId: currentId,
            projectId: nextCriteriaId,
          });
        } , 2000)
      }
    }

    const updateLocalFilter = useCallback((data: any) => {
      updateData();

      requestDataRef.current = {
       ...data
     }
    }, [requestDataRef.current, updateData])


    const goPrev = useCallback(() => {
      if (prevCriteriaId !== '' && prevCriteriaId !== id) {
        history.push(CreateLinkTo.project(id))
        updateLocalFilter({
          competitionId: currentId,
          projectId: prevCriteriaId,
        });
      }
    }, [history, prevCriteriaId, id, currentId, updateLocalFilter])

    const onTabChange = (tab: string) => {
      resetData();
      setActiveTabKey(tab);
      sessionStorage.setItem('voteId', tab)
      setQueryParams({ currentCompetitionId: tab}, { replace: true })
    };
  
    const onUpdateValues = (values: any, id: string) => {
      let common = criteriaList;

     const newVal = common?.map((c) => {
        if (c?.voteCriteriaId === id) {
          return {...values}
        }
        return c;
      })

      setVote({
        criteriaList: newVal,
        ...(newVal?.every((i: any) => i?.voteValue !== -1) && { currentList: newVal} )
      })
    }
  
    const isTwoColumns = useMemo(() => {
      if(nomination?.customVoteMaxValue){
        return nomination?.customVoteMaxValue > 5
      }
      return criterias?.some((i) => i?.maxValue > 5)
    }, [criterias, nomination]);
    
    const isDataLoading = useMemo(() => (!criteriaList?.length || !criterias?.length /*|| !isLoading*/) , [criteriaList, criterias])
  
    const isChecked = (id: string, val: number) => {
      const currentCrt = criteriaList?.find((c) => c?.voteCriteriaId === id);

      return (
        !!criteriaList?.length &&
        !!criterias?.length &&
        currentCrt &&
        currentCrt?.voteValue === val
      )
    }
  
    const calculateGrid = useCallback(() => {
      if (isMobile) {
        if (isTwoColumns) {
          return fullSize ? [GRID_TEMP.l, MARK_WIDTH.mob.m] : [GRID_TEMP.l, MARK_WIDTH.tablet.m]
        }
        return fullSize ? [GRID_TEMP.m, MARK_WIDTH.mob.l] : [GRID_TEMP.m, MARK_WIDTH.mob.l]
      } else if (isMac13 || smHeight) {
        if (isTwoColumns) {
          return fullSize ? [GRID_TEMP.l, MARK_WIDTH.tablet.m] : [GRID_TEMP.m, MARK_WIDTH.tablet.m]
        }
        return fullSize ? [GRID_TEMP.m, MARK_WIDTH.tablet.l] : [GRID_TEMP.m, MARK_WIDTH.tablet.s]
      } else {
        if (isTwoColumns) {
          return fullSize ? [GRID_TEMP.l, MARK_WIDTH.desktop.ml] : [GRID_TEMP.l, MARK_WIDTH.desktop.xs]
        }
        return fullSize ? [GRID_TEMP.m, MARK_WIDTH.desktop.l] : [GRID_TEMP.m, MARK_WIDTH.desktop.s]
      }
    }, [isMac13, smHeight, fullSize, isMobile, isTwoColumns])
  
    const calculateMarkW_H = useCallback(() => {
      if (isMobile) {
        if (isTwoColumns) {
          return fullSize ? [MARK_WIDTH.mob.m, MARK_HEIGHT.mob.m] : [MARK_WIDTH.mob.m, MARK_HEIGHT.mob.m]
        }
        return fullSize ? [MARK_WIDTH.mob.l, MARK_HEIGHT.mob.m] : [MARK_WIDTH.mob.s, MARK_HEIGHT.mob.xs]
      } else if (isMac13 || smHeight) {
        if (isTwoColumns) {
          return fullSize ? [MARK_WIDTH.tablet.m, MARK_HEIGHT.tablet.m] : [MARK_WIDTH.tablet.m, MARK_HEIGHT.tablet.m]
        }
        return fullSize ? [MARK_WIDTH.tablet.l, MARK_HEIGHT.tablet.m] : [MARK_WIDTH.tablet.s, MARK_HEIGHT.tablet.xs]
      } else {
        if (isTwoColumns) {
          return fullSize ? [MARK_WIDTH.desktop.ml, MARK_HEIGHT.tablet.s] : [MARK_WIDTH.desktop.xs, MARK_HEIGHT.desktop.xs]
        }
        return fullSize ? [MARK_WIDTH.desktop.l, MARK_HEIGHT.desktop.m] : [MARK_WIDTH.desktop.s, MARK_HEIGHT.desktop.xs]
      }
  
    }, [isMac13, smHeight, fullSize, isMobile, isTwoColumns])
  
    if (
      ((isMac13 || smHeight) && position === VOTE_BLOCK_POSITION.top) ||
      (!(isMac13 || smHeight) && position === VOTE_BLOCK_POSITION.longread)
    ) {
      return null;
    }

    if (criterias?.length <= 0) return null;
  
    return <VoteWrapper position={position} fullSize={fullSize} isMobile={isMobile} direction="column"
                        directionMobile='column'
                        offsetLeft={[VOTE_BLOCK_POSITION.longread, VOTE_BLOCK_POSITION.bottom].includes(position) ? 0 : 24}
                        offsetLeftMobile={0} 
                        className={'vote-wrapper'}
                        // offsetTopMobile={isS ? 16 : 17}
            >
      <Dropdown
        offsetY={5}
        hideArrow
        orientation={'left'}
        maxWidth={isTwoColumns ? (isS ? 280 : 400) : (isS ? 280 : 329)}
        target={
          <ArrowTopIconWithText
            //@ts-ignore
            text={competitionTabs[activeTabKey]}
            shrimpIcon
            fill={"#909090"}
            fullLineText
          />
        }
      >
        {Object.keys(competitionTabs)?.map((key) => {
            return (
              <div key={key} onClick={() => {
                if (key === activeTabKey) return false;
                onTabChange(key);
              }}>
                <DropdownListItem
                  justify='space-between'
                  isActive={key === activeTabKey}
                >
                  <DropdownText isActive={key === activeTabKey}>
                    {competitionTabs[key]}
                  </DropdownText>
                  <ApprovedIcon fill={themeWhite.icon.active} display={key === activeTabKey}/>
                </DropdownListItem>
              </div>
            )
          }
        )}
      </Dropdown>
      <FlexBox direction="column" directionMobile='column'>
        <VoteTitle fullSize={fullSize}>
          {t('project.evaluate')}
        </VoteTitle>
        {!criteriaList?.length ? (
          <FlexBox style={{ height: '150px' }} width={'100%'} widthMobile={'100%'} justify="center" justifyMobile="center" align="center" alignMobile="center">
            <ProgressBar 
              text={''} 
              loading={true} 
              color={theme.progressbar.color} 
            />
          </FlexBox>
        ) : criterias.map((item, i) => {
          const calculateMarks = () => {
            const arr = Array.from(Array(item.maxValue + 1).keys());
            arr.shift();
            return arr;
          };
          const marks = calculateMarks();
          const [columnsGrid, widthGrid] = calculateGrid();
          const [width, height] = calculateMarkW_H();
          return (
            <CriteryWrapper key={i} twoColumns={isTwoColumns} fullSize={fullSize} position={position}>
              <FlexBox direction={'column'} align={(isTwoColumns && !fullSize) ? 'start' : 'center'}
                       offsetBottom={(isTwoColumns && !fullSize) ? 8 : 0}
                       justify={(isTwoColumns && !fullSize) ? 'flex-start' : 'center'}
                       justifyMobile={isS ? 'start' : 'center'}>
                <CriteryName twoColumns={isTwoColumns} align={'center'} fullSize={fullSize}>
                  {item.name}
                </CriteryName>
              </FlexBox>
                <MarkList twoColumns={isTwoColumns} fullSize={fullSize} columnsGrid={columnsGrid} widthGrid={widthGrid}>
                {marks.map((m, f) => {
                  return (
                    <Container
                      twoColumns={isTwoColumns}
                      fullSize={fullSize}
                      key={f}
                      width={width}
                      height={height}
                      isMobile={isMobile}
                      isLoading={(isLoading || loaderVisible) && !!criteriaList?.length}
                      onClick={() => {
                        let cpy = /*currentList?.length ? currentList : */criteriaList;
                        const obj = cpy?.find((c) => c?.voteCriteriaId === criterias?.[i]?.voteCriteriaId)

                        const isResetValue = obj?.voteValue === m;

                          onUpdateValues({
                            competitionId: competition?.competitionId,
                            nominationId: nomination?.nominationID,
                            projectId: project.projectId,
                            //seasonStageEnum: stage?.seasonStageEnum,
                            //@ts-ignore
                            profileId: profile?.designerId,
                            profileEmail: (profile as any)?.profileEmail,
                            voteCriteriaId: criterias[i].voteCriteriaId,
                            voteValue: isResetValue ? -1 : m,
                          }, criterias[i].voteCriteriaId)


  
                        // cpy[criterias[i].voteCriteriaId] = {
                        //   competitionId: competition?.competitionId,
                        //   nominationId: nomination?.nominationID,
                        //   projectId: project.projectId,
                        //   //seasonStageEnum: stage?.seasonStageEnum,
                        //   //@ts-ignore
                        //   profileId: profile?.designerId,
                        //   profileEmail: (profile as any)?.profileEmail,
                        //   voteCriteriaId: criterias[i].voteCriteriaId,
                        //   voteValue: isResetValue ? -1 : m,
                        // };

                        // onUpdateValues(cpy, criterias[i].voteCriteriaId)
  
                        // onSave();
                        // setSelectedCriteries((prev) => {
                        //   const cpy = { ...prev };
                        //   const { voteValue } = cpy[criterias[i].voteCriteriaId];
                        //   const isResetValue = voteValue === m;
  
                        //   cpy[criterias[i].voteCriteriaId] = {
                        //     competitionId: competition?.competitionId,
                        //     nominationId: nomination?.nominationID,
                        //     projectId: project.projectId,
                        //     //seasonStageEnum: stage?.seasonStageEnum,
                        //     //@ts-ignore
                        //     profileId: profile?.designerId,
                        //     profileEmail: (profile as any)?.profileEmail,
                        //     voteCriteriaId: criterias[i].voteCriteriaId,
                        //     voteValue: isResetValue ? -1 : m,
                        //   };
                        //   return cpy;
                        // })
                        ;
                      }}
                      checked={isChecked(criterias?.[i]?.voteCriteriaId, m)}
                      data-name={`group${i}`}
                    >
                      <RectangleCount className="text" twoColumns={isTwoColumns} fullSize={fullSize}>
                        {m}
                      </RectangleCount>
                    </Container>
                  );
                })}
              </MarkList>
            </CriteryWrapper>
          );
        })}
      </FlexBox>
      <FlexBox direction={fullSize ? 'row' : 'column'} directionMobile={fullSize && !isS ? 'row' : 'column'}
               gy={fullSize && !isS ? 0 : 8} /*gyMobile={fullSize && !isS ? 0 : 8}*/ align={fullSize ? 'center' : 'normal'}
               justify={fullSize ? 'flex-end' : 'normal'} gx={fullSize && !isS ? 16 : 0}>
        {isDataLoading ? (
          <>
            {/* <SkelectonCard height={38} width={'100%'} style={{ borderRadius: 3 }} offsetBottom={fullSize ? 0 : 8}
                           offsetTop={24} offsetTopMobile={16}/> */}
            {/* <SkelectonCard offsetTop={24} height={38} width={'100%'} style={{ borderRadius: 3 }}/> */}
            <VoteButton fullSize={fullSize} hgt={38} disabled />
          </>
        ) : (
          <>
            {/* <VoteButton fullSize={fullSize} hgt={38} disabled={!isPrevButtonEnabled}
                        onClick={goPrev}>
              {t('prev_competition')}
            </VoteButton> */}
            <VoteButton 
              fullSize={fullSize} 
              hgt={38} 
              /*data-tip={disabledNextText}*/ 
              disabled={disableNext || loaderVisible} 
              fakeDisabled={!isNextButtonEnabled}
              onClick={goNext}
            >
              {loaderVisible ? (
                <ProgressBar 
                  text={''} 
                  loading={true} 
                  color={theme.progressbar.color} 
                />
              ) : (
                <>
                  {t('next_competition')}
                  {isNextButtonEnabled && <ArrowRight/>}
                </>
              )}
            </VoteButton>
          </>
        )}
  
      </FlexBox>
      <ReactTooltip/>
    </VoteWrapper>
  }

  export default VoteBlock;import { API, Competition,CompetitionAPI,LangObject, PageModel } from "@brg/api";
import { useProfile } from "@brg/auth";
import { Dropdown, DropdownListItem, FlexBox, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { LayoutConst } from "core";
import { useState, FC, useMemo, useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { ApplicationTheme } from "shared/themes";
import { VOTE_BLOCK_POSITION } from "../../sections/ps-bottom";
import useQueryState from "shared/hooks/useQueryState";
import { STATUSES } from "_competition/const";
import { CreateLinkTo } from "shared/constants/linkTo";
import { GRID_TEMP, MARK_HEIGHT, MARK_WIDTH } from "../const/markSizes";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { Container, CriteryName, CriteryWrapper, DropdownText, MarkList, RectangleCount, SkelectonCard, VoteButton, VoteTitle, VoteWrapper } from "./styles";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ReactTooltip from "react-tooltip";
import { getCompetitionTitle } from "_competition/pages/AllCompetitionsPage/helpers/competitionUtils";
import { PROJECT_VOTE_STATUS, useVoteContest } from "core/providers/VoteProvider";
import { ProgressBar } from "shared/icons/Progress";
import { useTheme } from "styled-components";
import { useGetFriendlyUrlParam } from "shared/hooks/useGetFriendlyUrlParam";

const ArrowRight: FC = () => {
    return (
      <svg width="9" height="12" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.65801 7L0.723468 12.7402C0.425507 13.0284 0.425511 13.4957 0.723476 13.7839C1.02144 14.0721 1.50453 14.072 1.80249 13.7838L8.27653 7.52183C8.57449 7.23363 8.57449 6.76637 8.27653 6.47817L1.80249 0.216154C1.50453 -0.0720489 1.02144 -0.0720514 0.723476 0.216148C0.425511 0.504347 0.425507 0.971612 0.723468 1.25981L6.65801 7Z"
          fill="#FEFEFE"/>
      </svg>
    )
  }

export interface Criteria {
    voteCriteriaId: string;
    name: string | LangObject[];
    nominationId?: string;
    minValue: number;
    maxValue: number;
    weight?: number;
    currentLang?: string;
    isNew?: boolean;
  }

const VoteBlock: FC<{ project: any, fullSize?: boolean, position: VOTE_BLOCK_POSITION}> = ({
    project,
    fullSize,
    position,
  }) => {
  
    const isMobile = useIsMobile();
    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const id = useGetFriendlyUrlParam("id");
    const requestDataRef = useRef<any>(null);
    const themeWhite = ApplicationTheme.white;
    const profile = useProfile();
    const toasts = useToasts();
    const theme = useTheme();
    const [competition, setCompetition] = useState<Competition>();
    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [loaderVisible, setLoaderVisible] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState<string | undefined>();
    const [disableNext, setDisableNext] = useState(false);
    const [nextUnrated, setNextUnrated] = useState<string>();
    const [{ currentCompetitionId }, setQueryParams] = useQueryState();
  
    const { 
      criteriaList,
      currentList, 
      currentCompId,
      isLoading, 
      voteEnd, 
      nextCriteriaId,
      prevCriteriaId, 
      setFilter,
      setVote,
      resetData,
      updateData, 
    } = useVoteContest();

    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);
  
    //Номинация
    const nomination = useMemo(
      () => competition?.nominations?.length ? competition.nominations[0] : null,
      [competition]
    );

    const criterias = useMemo(
      () => (((nomination as any)?.voteCriterias as Criteria[]) ?? [])
        .map(x => {
          return {...x, maxValue: nomination?.customVoteMaxValue || x.maxValue} as Criteria
        }),
      [nomination]
    );

    const competitionIds = useMemo(() => {
      //@ts-ignore
      const competitionIds: Nullable<string[]> = project?.competitionApproves?.map(({ competitionId }) => competitionId);
      return competitionIds;
    }, [project]);

    useEffect(() => {
      if (competitions.length > 0 && activeTabKey) {
        setCompetition(competitions.find(x => x.competitionId === activeTabKey));
      } else {
        setCompetition(undefined);
      }
    }, [competitions, activeTabKey]);

    const fetchCompetitions = () => {
        CompetitionAPI.GetList({
          initTags: true,
          competitionIds: competitionIds,
          competitionStatus: [STATUSES.Voting.valueOf()],
          byJuryIds: [profile?.designerId],
          exams: true,
          includeRatings: true
        })
          .then((v) => v.json())
          .then((v) => API.toLang<PageModel<Competition>>(v, i18n?.language))
          .then((v) => {
            setCompetitions(v.data)
          });
   
    }
  
    const competitionTabs = useMemo(() => {
      const tabs: Record<string, string> = {};
  
      competitions.forEach(x => {
        //@ts-ignore
        tabs[x.competitionId] = getCompetitionTitle(x);
      });
  
      return tabs;
    }, [competitions]);
  
    //@ts-ignore
    const currentId = useMemo(() => {
      const storedCompetitionId = currentCompetitionId || sessionStorage.getItem('voteId');
      //@ts-ignore
      return !!project?.competitionApproves?.find?.(({ competitionId }) => competitionId === (storedCompetitionId)) ? storedCompetitionId : currentCompId
    }, [project, currentCompId, currentCompetitionId])

    // useEffect(() => {
    //   if (activeTabKey) {
    //     setCompetititionId(
    //       Object.keys(competitionTabs)?.find(
    //         (k) => k === activeTabKey) || ''
    //     )
    //   }
    // }, [activeTabKey, competitionTabs])
  
    useEffect(() => {
      const keys = Object.keys(competitionTabs);
  
      if ((keys && keys.length > 0) || currentId) {
        setActiveTabKey(currentId || keys[0]);
      } else {
        setActiveTabKey(undefined);
      }
  
    }, [competitionTabs, currentId])

    // console.log(`tst crt: ${criteriaList?.[0]?.projectId} - curr: ${project?.projectId} - next: ${nextCriteriaId}` )

    useEffect(() => {
      if (profile && requestDataRef?.current?.projectId === id && requestDataRef.current?.competitionId === currentId && !isLoading) {
        setFilter({
          ...requestDataRef?.current,
          competitionStatus: [STATUSES.Voting.valueOf()],
          profile: profile.designerId,
          competitionId: currentId,
          lang: i18n.language,
          disableRequest: !project?.competitionIds?.length
        })
      }
    }, [i18n.language, project, currentId, setFilter, isLoading, competitionIds, requestDataRef.current, id, profile]);

      //@ts-ignore
      requestDataRef.current = {
        competitionId: currentId,
        competitionIds: competitionIds,
        disableRequest: !project?.competitionIds?.length,
        projectId: id
      };

      useEffect(() => {
        if (profile && competitionIds?.length) {
          fetchCompetitions()
        } 
      } , [profile, competitionIds])

      useEffect(() => {
        if (!currentCompetitionId && competition && nomination) {
          setQueryParams({ 
            currentCompetitionId: competition?.competitionId
          })
        }
      } , [
        currentCompetitionId, 
        competition, 
        nomination, 
        setQueryParams
      ])

      useEffect(() => {
        resetData && resetData()
      }, [])
    
    // const isEqual = useMemo(() => {
    //   return !!Object.values(criteriaList)?.length && 
    //   !!Object.values(currentList)?.length && 
    //   Object.values(criteriaList).length === Object.values(currentList).length 
    // }, [criteriaList, currentList])
  
    const hasVoteValues = useMemo(
      () => (!isLoading && !!competition && criteriaList && (Object.values(criteriaList)?.every(({ voteValue }) => voteValue !== -1))) , [competition, isLoading, criteriaList])
  
    const isNextButtonEnabled = useMemo(() => {
      return nextCriteriaId !== '' && !isLoading && !!competition && criteriaList && (Object.values(criteriaList)?.every(({ voteValue }) => voteValue !== -1) || !!nextUnrated) && hasVoteValues
    }, [criteriaList, nextUnrated, competition, isLoading, nextCriteriaId, hasVoteValues])

    const showedEndModal = useMemo(
      () => {
        if (voteEnd === PROJECT_VOTE_STATUS.end) return true;
        else {
          let voteList = JSON.parse(
            JSON.stringify(
              localStorage.getItem(
                'showedVoteModal'
              ) ?? '[]'
            )
          );
          if (!Array.isArray(voteList)) {
            voteList = [voteList]
          }

          return voteList?.includes(currentId) 
        }
      } , [voteEnd, currentId])
    // const isPrevButtonEnabled = useMemo(() => (prevCriteriaId !== '' && prevCriteriaId !== id), [prevCriteriaId, id])
    const isPrevButtonEnabled = false;

    const goNext = () => {

      if (showedEndModal) {
        toasts.error(t('vote_over'));
        return;
      }

      if (!isNextButtonEnabled) {
        toasts.error(t('fill_vote'));
        return;
      }

      if (nextCriteriaId !== '') {

        setLoaderVisible(true);

        setTimeout(() => {
          history.push(`${CreateLinkTo.project(nextCriteriaId ?? '')}?currentCompetitionId=${currentId}`);
        
          updateLocalFilter({
            competitionId: currentId,
            projectId: nextCriteriaId,
          });
        } , 2000)
      }
    }

    const updateLocalFilter = useCallback((data: any) => {
      updateData();

      requestDataRef.current = {
       ...data
     }
    }, [requestDataRef.current, updateData])


    const goPrev = useCallback(() => {
      if (prevCriteriaId !== '' && prevCriteriaId !== id) {
        history.push(CreateLinkTo.project(id))
        updateLocalFilter({
          competitionId: currentId,
          projectId: prevCriteriaId,
        });
      }
    }, [history, prevCriteriaId, id, currentId, updateLocalFilter])

    const onTabChange = (tab: string) => {
      resetData();
      setActiveTabKey(tab);
      sessionStorage.setItem('voteId', tab)
      setQueryParams({ currentCompetitionId: tab}, { replace: true })
    };
  
    const onUpdateValues = (values: any, id: string) => {
      let common = criteriaList;

     const newVal = common?.map((c) => {
        if (c?.voteCriteriaId === id) {
          return {...values}
        }
        return c;
      })

      setVote({
        criteriaList: newVal,
        ...(newVal?.every((i: any) => i?.voteValue !== -1) && { currentList: newVal} )
      })
    }
  
    const isTwoColumns = useMemo(() => {
      if(nomination?.customVoteMaxValue){
        return nomination?.customVoteMaxValue > 5
      }
      return criterias?.some((i) => i?.maxValue > 5)
    }, [criterias, nomination]);
    
    const isDataLoading = useMemo(() => (!criteriaList?.length || !criterias?.length /*|| !isLoading*/) , [criteriaList, criterias])
  
    const isChecked = (id: string, val: number) => {
      const currentCrt = criteriaList?.find((c) => c?.voteCriteriaId === id);

      return (
        !!criteriaList?.length &&
        !!criterias?.length &&
        currentCrt &&
        currentCrt?.voteValue === val
      )
    }
  
    const calculateGrid = useCallback(() => {
      if (isMobile) {
        if (isTwoColumns) {
          return fullSize ? [GRID_TEMP.l, MARK_WIDTH.mob.m] : [GRID_TEMP.l, MARK_WIDTH.tablet.m]
        }
        return fullSize ? [GRID_TEMP.m, MARK_WIDTH.mob.l] : [GRID_TEMP.m, MARK_WIDTH.mob.l]
      } else if (isMac13 || smHeight) {
        if (isTwoColumns) {
          return fullSize ? [GRID_TEMP.l, MARK_WIDTH.tablet.m] : [GRID_TEMP.m, MARK_WIDTH.tablet.m]
        }
        return fullSize ? [GRID_TEMP.m, MARK_WIDTH.tablet.l] : [GRID_TEMP.m, MARK_WIDTH.tablet.s]
      } else {
        if (isTwoColumns) {
          return fullSize ? [GRID_TEMP.l, MARK_WIDTH.desktop.ml] : [GRID_TEMP.l, MARK_WIDTH.desktop.xs]
        }
        return fullSize ? [GRID_TEMP.m, MARK_WIDTH.desktop.l] : [GRID_TEMP.m, MARK_WIDTH.desktop.s]
      }
    }, [isMac13, smHeight, fullSize, isMobile, isTwoColumns])
  
    const calculateMarkW_H = useCallback(() => {
      if (isMobile) {
        if (isTwoColumns) {
          return fullSize ? [MARK_WIDTH.mob.m, MARK_HEIGHT.mob.m] : [MARK_WIDTH.mob.m, MARK_HEIGHT.mob.m]
        }
        return fullSize ? [MARK_WIDTH.mob.l, MARK_HEIGHT.mob.m] : [MARK_WIDTH.mob.s, MARK_HEIGHT.mob.xs]
      } else if (isMac13 || smHeight) {
        if (isTwoColumns) {
          return fullSize ? [MARK_WIDTH.tablet.m, MARK_HEIGHT.tablet.m] : [MARK_WIDTH.tablet.m, MARK_HEIGHT.tablet.m]
        }
        return fullSize ? [MARK_WIDTH.tablet.l, MARK_HEIGHT.tablet.m] : [MARK_WIDTH.tablet.s, MARK_HEIGHT.tablet.xs]
      } else {
        if (isTwoColumns) {
          return fullSize ? [MARK_WIDTH.desktop.ml, MARK_HEIGHT.tablet.s] : [MARK_WIDTH.desktop.xs, MARK_HEIGHT.desktop.xs]
        }
        return fullSize ? [MARK_WIDTH.desktop.l, MARK_HEIGHT.desktop.m] : [MARK_WIDTH.desktop.s, MARK_HEIGHT.desktop.xs]
      }
  
    }, [isMac13, smHeight, fullSize, isMobile, isTwoColumns])
  
    if (
      ((isMac13 || smHeight) && position === VOTE_BLOCK_POSITION.top) ||
      (!(isMac13 || smHeight) && position === VOTE_BLOCK_POSITION.longread)
    ) {
      return null;
    }

    if (criterias?.length <= 0) return null;
  
    return <VoteWrapper position={position} fullSize={fullSize} isMobile={isMobile} direction="column"
                        directionMobile='column'
                        offsetLeft={[VOTE_BLOCK_POSITION.longread, VOTE_BLOCK_POSITION.bottom].includes(position) ? 0 : 24}
                        offsetLeftMobile={0} 
                        className={'vote-wrapper'}
                        // offsetTopMobile={isS ? 16 : 17}
            >
      <Dropdown
        offsetY={5}
        hideArrow
        orientation={'left'}
        maxWidth={isTwoColumns ? (isS ? 280 : 400) : (isS ? 280 : 329)}
        target={
          <ArrowTopIconWithText
            //@ts-ignore
            text={competitionTabs[activeTabKey]}
            shrimpIcon
            fill={"#909090"}
            fullLineText
          />
        }
      >
        {Object.keys(competitionTabs)?.map((key) => {
            return (
              <div key={key} onClick={() => {
                if (key === activeTabKey) return false;
                onTabChange(key);
              }}>
                <DropdownListItem
                  justify='space-between'
                  isActive={key === activeTabKey}
                >
                  <DropdownText isActive={key === activeTabKey}>
                    {competitionTabs[key]}
                  </DropdownText>
                  <ApprovedIcon fill={themeWhite.icon.active} display={key === activeTabKey}/>
                </DropdownListItem>
              </div>
            )
          }
        )}
      </Dropdown>
      <FlexBox direction="column" directionMobile='column'>
        <VoteTitle fullSize={fullSize}>
          {t('project.evaluate')}
        </VoteTitle>
        {!criteriaList?.length ? (
          <FlexBox style={{ height: '150px' }} width={'100%'} widthMobile={'100%'} justify="center" justifyMobile="center" align="center" alignMobile="center">
            <ProgressBar 
              text={''} 
              loading={true} 
              color={theme.progressbar.color} 
            />
          </FlexBox>
        ) : criterias.map((item, i) => {
          const calculateMarks = () => {
            const arr = Array.from(Array(item.maxValue + 1).keys());
            arr.shift();
            return arr;
          };
          const marks = calculateMarks();
          const [columnsGrid, widthGrid] = calculateGrid();
          const [width, height] = calculateMarkW_H();
          return (
            <CriteryWrapper key={i} twoColumns={isTwoColumns} fullSize={fullSize} position={position}>
              <FlexBox direction={'column'} align={(isTwoColumns && !fullSize) ? 'start' : 'center'}
                       offsetBottom={(isTwoColumns && !fullSize) ? 8 : 0}
                       justify={(isTwoColumns && !fullSize) ? 'flex-start' : 'center'}
                       justifyMobile={isS ? 'start' : 'center'}>
                <CriteryName twoColumns={isTwoColumns} align={'center'} fullSize={fullSize}>
                  {item.name}
                </CriteryName>
              </FlexBox>
                <MarkList twoColumns={isTwoColumns} fullSize={fullSize} columnsGrid={columnsGrid} widthGrid={widthGrid}>
                {marks.map((m, f) => {
                  return (
                    <Container
                      twoColumns={isTwoColumns}
                      fullSize={fullSize}
                      key={f}
                      width={width}
                      height={height}
                      isMobile={isMobile}
                      isLoading={(isLoading || loaderVisible) && !!criteriaList?.length}
                      onClick={() => {
                        let cpy = /*currentList?.length ? currentList : */criteriaList;
                        const obj = cpy?.find((c) => c?.voteCriteriaId === criterias?.[i]?.voteCriteriaId)

                        const isResetValue = obj?.voteValue === m;

                          onUpdateValues({
                            competitionId: competition?.competitionId,
                            nominationId: nomination?.nominationID,
                            projectId: project.projectId,
                            //seasonStageEnum: stage?.seasonStageEnum,
                            //@ts-ignore
                            profileId: profile?.designerId,
                            profileEmail: (profile as any)?.profileEmail,
                            voteCriteriaId: criterias[i].voteCriteriaId,
                            voteValue: isResetValue ? -1 : m,
                          }, criterias[i].voteCriteriaId)


  
                        // cpy[criterias[i].voteCriteriaId] = {
                        //   competitionId: competition?.competitionId,
                        //   nominationId: nomination?.nominationID,
                        //   projectId: project.projectId,
                        //   //seasonStageEnum: stage?.seasonStageEnum,
                        //   //@ts-ignore
                        //   profileId: profile?.designerId,
                        //   profileEmail: (profile as any)?.profileEmail,
                        //   voteCriteriaId: criterias[i].voteCriteriaId,
                        //   voteValue: isResetValue ? -1 : m,
                        // };

                        // onUpdateValues(cpy, criterias[i].voteCriteriaId)
  
                        // onSave();
                        // setSelectedCriteries((prev) => {
                        //   const cpy = { ...prev };
                        //   const { voteValue } = cpy[criterias[i].voteCriteriaId];
                        //   const isResetValue = voteValue === m;
  
                        //   cpy[criterias[i].voteCriteriaId] = {
                        //     competitionId: competition?.competitionId,
                        //     nominationId: nomination?.nominationID,
                        //     projectId: project.projectId,
                        //     //seasonStageEnum: stage?.seasonStageEnum,
                        //     //@ts-ignore
                        //     profileId: profile?.designerId,
                        //     profileEmail: (profile as any)?.profileEmail,
                        //     voteCriteriaId: criterias[i].voteCriteriaId,
                        //     voteValue: isResetValue ? -1 : m,
                        //   };
                        //   return cpy;
                        // })
                        ;
                      }}
                      checked={isChecked(criterias?.[i]?.voteCriteriaId, m)}
                      data-name={`group${i}`}
                    >
                      <RectangleCount className="text" twoColumns={isTwoColumns} fullSize={fullSize}>
                        {m}
                      </RectangleCount>
                    </Container>
                  );
                })}
              </MarkList>
            </CriteryWrapper>
          );
        })}
      </FlexBox>
      <FlexBox direction={fullSize ? 'row' : 'column'} directionMobile={fullSize && !isS ? 'row' : 'column'}
               gy={fullSize && !isS ? 0 : 8} /*gyMobile={fullSize && !isS ? 0 : 8}*/ align={fullSize ? 'center' : 'normal'}
               justify={fullSize ? 'flex-end' : 'normal'} gx={fullSize && !isS ? 16 : 0}>
        {isDataLoading ? (
          <>
            {/* <SkelectonCard height={38} width={'100%'} style={{ borderRadius: 3 }} offsetBottom={fullSize ? 0 : 8}
                           offsetTop={24} offsetTopMobile={16}/> */}
            {/* <SkelectonCard offsetTop={24} height={38} width={'100%'} style={{ borderRadius: 3 }}/> */}
            <VoteButton fullSize={fullSize} hgt={38} disabled />
          </>
        ) : (
          <>
            {/* <VoteButton fullSize={fullSize} hgt={38} disabled={!isPrevButtonEnabled}
                        onClick={goPrev}>
              {t('prev_competition')}
            </VoteButton> */}
            <VoteButton 
              fullSize={fullSize} 
              hgt={38} 
              /*data-tip={disabledNextText}*/ 
              disabled={disableNext || loaderVisible} 
              fakeDisabled={!isNextButtonEnabled}
              onClick={goNext}
            >
              {loaderVisible ? (
                <ProgressBar 
                  text={''} 
                  loading={true} 
                  color={theme.progressbar.color} 
                />
              ) : (
                <>
                  {t('next_competition')}
                  {isNextButtonEnabled && <ArrowRight/>}
                </>
              )}
            </VoteButton>
          </>
        )}
  
      </FlexBox>
      <ReactTooltip/>
    </VoteWrapper>
  }

  export default VoteBlock;